export function shortenName(first, last) {
  if (first) {
    let name = first;
    if (last) {
      name = `${name} ${last.charAt(0)}.`;
    }
    return name;
  }
  return '';
}
